import { Box, IconButton, ImageListItem, Toolbar, Typography } from "@mui/material";
import MuiAppBar from '@mui/material/AppBar';
import { styled } from '@mui/system';

import MenuIcon from '@mui/icons-material/Menu';
import DarkModeIcon from '@mui/icons-material/DarkMode';


const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const Username = styled(Box)({
    fontSize: '1rem',
    fontWeight: '500',
    color: '#fff',
    display: 'flex',
    alignItems: 'center'
});

const NavbarAdmin = ({ openSidebar, handleSidebarOpen, darkMode, setDarkMode, currentUser }) => {

    return (
        <AppBar position="fixed" open={openSidebar} style={{ background: 'linear-gradient(90.59deg, rgb(41, 89, 154) -2.73%, rgb(35, 43, 54) 73.29%)' }}>
            <Toolbar>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={handleSidebarOpen}
                    edge="start"
                    sx={{ mr: 2, ...(openSidebar && { display: 'none' }) }}
                >
                    <MenuIcon />
                </IconButton>

                <img
                    // srcSet={`${item.img}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                    src={'https://virtualclub.vip/assets/imgsite2/logo.png'}
                    alt="Logo fourbet"
                    loading="lazy"
                    width="100px"
                />

                <Box sx={{ flexGrow: 1 }} />
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <IconButton
                        color="inherit"
                        aria-label="dark mode"
                        onClick={() => setDarkMode(!darkMode)}
                    >
                        <DarkModeIcon />
                    </IconButton>
                    <Username>Admin</Username>
                </Box>
            </Toolbar>
        </AppBar>
    )
}
export default NavbarAdmin;